import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';

interface DiaDoCalendario {
  data: moment.Moment;
  noMes: boolean;
  hoje: boolean;
  futuro: boolean;
  inicio: boolean;
  fim: boolean;
  noIntervalo: boolean;
}

const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
];

const DIAS_DA_SEMANA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

@Component({
  selector: 'c-supplier-files-period-modal',
  templateUrl: './supplier-files-period-modal.component.html',
  styleUrls: ['./supplier-files-period-modal.component.scss']
})
export class SupplierFilesPeriodModalComponent implements OnInit {

  /** Injetados pelo ModalService via contentInitialState */
  readonly dataInicio: string;
  readonly dataFim: string;
  readonly maxIntervaloDias: number;
  /** Fecha o modal; atribuido pelo ComponentLoaderService */
  readonly destroy: () => void;

  @Output() periodoSelecionado = new EventEmitter<{ dataInicio: string; dataFim: string }>();

  readonly diasDaSemana = DIAS_DA_SEMANA;

  mesReferencia: moment.Moment;
  selecaoInicio: moment.Moment;
  selecaoFim: moment.Moment;
  diasDoMes: DiaDoCalendario[] = [];

  private readonly hoje = moment().startOf('day');

  ngOnInit() {
    this.selecaoInicio = this.dataInicio ? moment(this.dataInicio) : null;
    this.selecaoFim = this.dataFim ? moment(this.dataFim) : null;
    this.mesReferencia = (this.selecaoFim || this.hoje).clone().startOf('month');
    this.montarDias();
  }

  get nomeDoMes() {
    return `${MESES[this.mesReferencia.month()]} de ${this.mesReferencia.year()}`;
  }

  get erro(): string {
    if (!this.selecaoInicio || !this.selecaoFim) { return null; }

    const dias = this.selecaoFim.diff(this.selecaoInicio, 'days');
    if (dias > this.maxIntervaloDias) {
      return `o intervalo não pode passar de ${this.maxIntervaloDias} dias.`;
    }
    return null;
  }

  get podeAplicar() {
    return !!this.selecaoInicio && !!this.selecaoFim && !this.erro;
  }

  mesAnterior() {
    this.mesReferencia = this.mesReferencia.clone().subtract(1, 'month');
    this.montarDias();
  }

  mesProximo() {
    this.mesReferencia = this.mesReferencia.clone().add(1, 'month');
    this.montarDias();
  }

  atalho(diasAtras: number) {
    this.selecaoFim = this.hoje.clone();
    this.selecaoInicio = this.hoje.clone().subtract(diasAtras, 'days');
    this.mesReferencia = this.selecaoFim.clone().startOf('month');
    this.montarDias();
  }

  selecionarDia(dia: DiaDoCalendario) {
    if (dia.futuro) { return; }

    if (!this.selecaoInicio || this.selecaoFim) {
      this.selecaoInicio = dia.data;
      this.selecaoFim = null;
    } else if (dia.data.isBefore(this.selecaoInicio, 'day')) {
      this.selecaoFim = this.selecaoInicio;
      this.selecaoInicio = dia.data;
    } else {
      this.selecaoFim = dia.data;
    }

    this.montarDias();
  }

  aplicar() {
    if (!this.podeAplicar) { return; }

    this.periodoSelecionado.emit({
      dataInicio: this.selecaoInicio.format('YYYY-MM-DD'),
      dataFim: this.selecaoFim.format('YYYY-MM-DD')
    });
    this.destroy();
  }

  cancelar() {
    this.destroy();
  }

  private montarDias() {
    const inicioDaGrade = this.mesReferencia.clone().startOf('month');
    inicioDaGrade.subtract(inicioDaGrade.day(), 'days');

    this.diasDoMes = Array.from({ length: 42 }, (_, indice) => {
      const data = inicioDaGrade.clone().add(indice, 'days');

      return {
        data,
        noMes: data.month() === this.mesReferencia.month(),
        hoje: data.isSame(this.hoje, 'day'),
        futuro: data.isAfter(this.hoje, 'day'),
        inicio: !!this.selecaoInicio && data.isSame(this.selecaoInicio, 'day'),
        fim: !!this.selecaoFim && data.isSame(this.selecaoFim, 'day'),
        noIntervalo: !!this.selecaoInicio && !!this.selecaoFim &&
          data.isAfter(this.selecaoInicio, 'day') && data.isBefore(this.selecaoFim, 'day')
      };
    });
  }

}
